export default "__VITE_ASSET__DWciTrNR__"